import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { environment } from "environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { LookupService } from 'app/webservice/lookup.service';
import { PlatformLocation } from '@angular/common';

@Pipe({name: "assetsByMemberOid"})
export class AssetsByMemberOidPipe implements PipeTransform {
  transform(items: any[], Oid: any): any[] {
    let values = items.filter( (item)=> {return (item.EntityOid === Oid);} );
    return values;
  }
}

@Component({
  selector: 'overdue-report',
  templateUrl: './overdue-report.component.html',
  styleUrls: ['./overdue-report.component.css']
})
export class OverdueReportComponent implements OnInit {
    
  public loading: boolean = false;
  public serviceStackUrl;
  public overDueAssets;
  public distinctMembers;
  public assetType;
  public today: number = Date.now();

  constructor(
    private route: ActivatedRoute, 
    private _lookup: LookupService,
    private _restService: RestService, 
    private _router: Router,
    platformLocation: PlatformLocation
  ) {
      
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.route.params.subscribe(params => {
      if (params['Type']) {

        this.loading = true;
        this.assetType = params['Type'];

        if (this.assetType === 'DVD') {
          this.assetType = 'Video';
        } else if (this.assetType === 'Book') {
          this.assetType = 'Books';
        }

        let url = this.serviceStackUrl +  'Asset-GetAgedCheckoutHistory';
        this._restService.post(url, {}).then(response => {
          console.log(response);
          for (let i = response.Data.Data.length - 1; i >= 0; i--) {
            if (response.Data.Data[i].Name === this.assetType) {            
              this.overDueAssets = response.Data.Data[i].CheckoutHistory;
            }
          }

          let unique = {};
          this.distinctMembers = [];
          for ( let i in this.overDueAssets ) {
            if ( typeof(unique[this.overDueAssets[i].EntityOid]) == "undefined") {
              this.distinctMembers.push(this.overDueAssets[i]);
            }
            unique[this.overDueAssets[i].EntityOid] = 0;
          }

          this.loading = false;
          window.setTimeout(() => {
            window.print();
          },500)
        });
      }
    });
  }

  ngOnInit() {
  
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/overdue-report/overdue-report.component.ts